
import { Component, Vue, Prop } from 'vue-property-decorator'
import { TimeUtil } from '@/helpers/TimeUtil'
import { commonModule, installationsModule, companyModule } from '@/store/modules/store-accessor'
import { templatesFilenameLanguage } from "@/helpers/data";
import FileSaver from 'file-saver';
import dayjs from "dayjs";
import PhotoCarouselViewer from '@/components/UI/PhotoCarouselViewer.vue';
import TheLoadingIndicator from "@/components/TheLoadingIndicator.vue"
import ExportMenu from "@/components/ExportMenu/ExportMenu.vue";

@Component({
  components: { PhotoCarouselViewer, TheLoadingIndicator, ExportMenu }
})

export default class InstallationsSideviewPhotosTab extends Vue {
 @Prop() installation: Record<string, any>;

 isDowloadingPhoto = false;
 isDownloadingExport = false;

  get photos() {
    return this.installation.images || [];
  }

  get photosExist() {
    return this.installation?.images?.length > 0
  }

  get tableIsLoading() {
    return installationsModule.sideviewTableIsLoading;
  }

  photoPath(photo: any) {
    return `${photo.base_url}/${photo.src}`
  }

  async deletePhoto(photo: any) {
    commonModule.showModal({ name: 'delete-installation-photo-modal', payload: { photo: photo } })
  }

  async downloadPhoto(photo: Record<string, any>) {
    this.isDowloadingPhoto = true;
    try {
      let downloadPhoto = await installationsModule.getInstallationPhoto({installationId: photo.installation_id, photoId: photo.id} );
      const photoSrcSplit = photo.src.split('.');
      let photoName = `${this.installation.info.tag_id}_${dayjs(photo.created_at).format('DD_MM_YYYY_HH_mm_ss')}`;

      photoName = photoSrcSplit.length === 2 ? `${photoName}.${photoSrcSplit[1]}` : `${photoName}.jpeg`
      downloadPhoto = new File([downloadPhoto], photoName);
      FileSaver.saveAs(downloadPhoto);
    } finally {
      this.isDowloadingPhoto = false;
    }
  }

  downloadExportLengthCheck() {
    return this.photos?.length > 0;
  }

  async donwloadPhotosExport() {
    this.isDownloadingExport = true;
    const data = {
      user_timezone: dayjs.tz.guess(),
      language: localStorage.getItem('lang'),
      format: 'zip',
      installation_id: this.installation.info.id,
    };

    try {
      const company = await companyModule.getCompanyInfo();
      const filename = `${templatesFilenameLanguage()}_${company.entity_name}_DfB_${data.installation_id}_photos_${dayjs().format('YYYY_MM_DD_HH_mm_ss')}.zip`.replace(/ /g, '_');
      const zip = await installationsModule.getInstallationSideviewPhotosExport(data);
      const file = new File([zip], filename);
      FileSaver.saveAs(file);
    } finally {
      this.isDownloadingExport = false;
    }
  }

  formatDate (date: Date): string {
    return TimeUtil.formatDateTime(date)
  }

  addPhotoToInstallation() {
    commonModule.showModal({ name: 'add-photo-to-installation-modal', payload: { installation: this.installation } })
  }

  editPhoto(photo: any) {
    commonModule.showModal({ name: 'edit-installation-photo-modal', payload: { photo: photo } })
  }

};
